export default __webpack_public_path__ + "static/media/tour-1.98156c00.jpg";